module.exports = __webpack_public_path__ + "img/log.038ddaa7.svg";